import { render, staticRenderFns } from "./Counselor.vue?vue&type=template&id=be1ab5bc&scoped=true"
import script from "./Counselor.vue?vue&type=script&lang=js"
export * from "./Counselor.vue?vue&type=script&lang=js"
import style0 from "./Counselor.vue?vue&type=style&index=0&id=be1ab5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ab5bc",
  null
  
)

export default component.exports